<template>
  <b-container fluid class="page publications">
    <h1>Publications</h1>
    <div
      class="search-section d-flex justify-content-start align-items-center flex-wrap"
    >
      <b-form-input
        v-model="current_search.text"
        class="search-bar"
        placeholder="Search by publication title"
      >
      </b-form-input>
      <b-button
        @click="handleSearch"
        class="search-button"
        :disabled="isSearchDisabled"
        >Search</b-button
      >
    </div>

    <div
      class="filter-section d-flex justify-content-start align-items-center flex-wrap"
    >
      <b-form-select
        id="year_dropdown"
        v-model="current_search.year"
        :options="allYears"
        class="dropdown-publications-years"
      ></b-form-select>
      <b-form-select
        id="type_dropdown"
        v-model="current_search.type"
        :options="allTypes"
        class="dropdown-publications-years"
      ></b-form-select>
    </div>

    <div class="search-params" v-if="!this.areLatestSearchParametersDefault()">
      <h3>
        Results for:
        {{
          this.latest_search.text !== ""
            ? '"' + this.latest_search.text + '"'
            : "*"
        }}{{
          this.latest_search.year !== "All Years"
            ? ", " + this.latest_search.year
            : ""
        }}{{
          this.latest_search.type !== "All Types"
            ? ", " + this.latest_search.type
            : ""
        }}
      </h3>
      <h5 class="results-found">({{ publications.length }} found)</h5>
    </div>

    <ul v-if="!isSearchingPublications" class="publications-list">
      <div
        v-for="(publication, idx) in publications"
        v-bind:key="publication.pub_authenticus_id"
      >
        <div v-if="idx == 0" class="year-division">
          {{ publication.year }}
        </div>
        <div
          v-else-if="publication.year !== publications[idx - 1].year"
          class="year-division"
        >
          {{ publication.year }}
        </div>
        <li style="margin-bottom: 1em">
          <span class="bullet-point">
            <font-awesome icon="square" />
          </span>
          <div class="publication-info">
            <a
              v-if="publication.pub_authenticus_id !== 'P-XXX-XXX'"
              class="d-flex"
              v-b-popover.hover.left="'See in Authenticus'"
              v-bind:href="
                'https://www.authenticus.pt/' + publication.pub_authenticus_id
              "
              target="_blank"
            >
              <!--<p class="pub-header pub-header-title">Title:&nbsp;</p>-->
              <p class="pub-header" style="margin-bottom: 5px; height: inherit">
                {{ publication.title }}
              </p>
            </a>
            <a
              v-else
              class="d-flex"
              v-b-popover.hover.left="'See publication'"
              v-bind:href="'' + publication.link"
              target="_blank"
            >
              <!--<p class="pub-header pub-header-title">Title:&nbsp;</p>-->
              <p class="pub-header" style="margin-bottom: 5px; height: inherit">
                {{ publication.title }}
              </p>
            </a>

            <div class="d-flex">
              <div class="d-flex">
                <!--<p class="pub-header">Authors:&nbsp;</p>-->
                <p
                  class="pub-authors"
                  style="margin-bottom: 5px; font-size: 0.95em"
                >
                  {{ publication.authorlist }}
                </p>
              </div>

              <div class="d-flex ml-3">
                <!--<p class="pub-header">Publication Year:&nbsp;</p>-->
                <p style="margin-bottom: 5px; font-size: 0.95em">
                  ({{ publication.year }})
                </p>
              </div>
            </div>

            <div
              class="d-flex"
              v-if="
                publication.pubtype == 'Journal Articles' && publication.volume
              "
            >
              <p
                style="
                  font-style: italic;
                  margin-bottom: 5px;
                  font-size: 0.95em;
                "
              >
                {{ publication.source }} (vol. {{ publication.volume }})
              </p>
            </div>
            <div
              class="d-flex"
              v-else-if="publication.pubtype == 'Journal Articles'"
            >
              <p
                style="
                  font-style: italic;
                  margin-bottom: 5px;
                  font-size: 0.95em;
                "
              >
                {{ publication.source }}
              </p>
            </div>
            <div
              class="d-flex"
              v-else-if="
                publication.pubtype == 'Conference Articles' &&
                publication.conference
              "
            >
              <p
                style="
                  font-style: italic;
                  margin-bottom: 5px;
                  font-size: 0.95em;
                "
              >
                {{ publication.conference }}
              </p>
            </div>
            <div class="d-flex" v-else>
              <p
                style="
                  font-style: italic;
                  margin-bottom: 5px;
                  font-size: 0.95em;
                "
              >
                {{ publication.source }}
              </p>
            </div>
          </div>
        </li>
      </div>
    </ul>
    <loading v-else class="loading-animation"></loading>
    <div v-if="next_publication_page_url !== null">
      <b-button
        class="load-more-button"
        variant="primary"
        v-if="!isLoadingMorePublications"
        @click="loadMorePublications"
      >
        Load More Publications
      </b-button>
      <loading class="loading-animation" v-else></loading>
    </div>
  </b-container>
</template>

<script>
import { getPaginationData, getSearchData, getByFullURL } from "@/api";
import Loading from "@/components/Loading.vue";

export default {
  name: "Publications",
  components: {
    Loading,
  },
  props: ["page"],
  data() {
    const options_year = [...this.page.available_years];
    const options_type = [...this.page.available_types];

    options_year.sort((y1, y2) => {
      const y1_int = parseInt(y1);
      const y2_int = parseInt(y2);

      return y1_int < y2_int ? 1 : y1_int === y2_int ? 0 : -1;
    });

    options_type.sort();

    options_year.unshift("All Years");
    options_type.unshift("All Types");

    this.getPaginatedData();

    return {
      publications: [],
      next_publication_page_url: null,
      isLoadingMorePublications: false,
      isSearchingPublications: false,

      allYears: options_year,
      allTypes: options_type,

      latest_search: {
        text: "",
        year: "All Years",
        type: "All Types",
      },

      current_search: {
        text: "",
        year: "All Years",
        type: "All Types",
      },
    };
  },
  methods: {
    loadMorePublications() {
      this.isLoadingMorePublications = true;
      getByFullURL(this.next_publication_page_url).then((response) => {
        this.next_publication_page_url = response.data.next;

        response.data.results.forEach((element) => {
          this.publications.push(element);
        });

        this.isLoadingMorePublications = false;
      });
    },
    async handleSearch() {
      this.areSearchParametersDefault()
        ? await this.getPaginatedData()
        : await this.search();

      this.latest_search.text = this.current_search.text;
      this.latest_search.year = this.current_search.year;
      this.latest_search.type = this.current_search.type;
    },
    getPaginatedData() {
      this.isSearchingPublications = true;
      getPaginationData("publications", {
        breast: 1,
      })
        .then((response) => {
          this.publications = response.data.results;
          this.next_publication_page_url = response.data.next;

          this.isSearchingPublications = false;
        })
        .catch(() => {
          this.isSearchingPublications = false;
        });
    },
    search() {
      this.isSearchingPublications = true;
      getSearchData("publications", {
        breast: 1,
        query: this.current_search.text,
        year: this.current_search.year,
        type: this.current_search.type,
      })
        .then((response) => {
          // Resets publications and sets new value
          const ordered_pub = response.data;

          ordered_pub.sort((p1, p2) => {
            const p1_year_int = parseInt(p1.year);
            const p2_year_int = parseInt(p2.year);

            return p1_year_int < p2_year_int
              ? 1
              : p1_year_int === p2_year_int
              ? 0
              : -1;
          });

          this.publications = [...ordered_pub];

          this.next_publication_page_url = null;
          this.isSearchingPublications = false;
        })
        .catch(() => {
          this.isSearchingPublications = false;
        });
    },
    areSearchParametersDefault() {
      return (
        this.current_search.text === "" &&
        this.current_search.year === "All Years" &&
        this.current_search.type === "All Types"
      );
    },
    areLatestSearchParametersDefault() {
      return (
        this.latest_search.text === "" &&
        this.latest_search.year === "All Years" &&
        this.latest_search.type === "All Types"
      );
    },
  },
  computed: {
    isSearchDisabled() {
      return (
        this.latest_search.text === this.current_search.text &&
        this.latest_search.year === this.current_search.year &&
        this.latest_search.type === this.current_search.type
      );
    },
  },
};
</script>

<style lang="scss">
.search-params {
  display: flex;
  gap: 1%;

  margin-top: 2%;

  align-items: center;
  justify-items: start;

  .results-found {
    color: $secondary-color !important;
  }

  @include media-breakpoint-down(sm) {
    flex-direction: column;

    justify-content: left !important;

    h1,
    h2,
    h3,
    h4,
    h5 {
      margin-left: 0px;
      margin-right: auto;

      font-size: 110% !important;
    }

    h3:first-child {
      margin-top: 3%;
    }
  }
}

.year-division {
  color: $primary-color;
  text-align: left;
  font-size: 1.2em;
  margin-top: 1em;
  margin-bottom: 1em;
  margin-left: -40px;
  border-bottom: dashed;
  border-bottom-color: $primary-color;
  border-bottom-width: thin;
}

.publications {
  h1 {
    margin-right: 4em;
  }
}

.load-more-button {
  display: block !important;
  margin-top: 6em !important;
  margin-right: auto !important;
  margin-left: auto !important;
}

.loading-animation {
  position: relative !important;
  transform: scale(0.6) !important;
}

.filter-section,
.search-section {
  display: flex;
  flex-direction: row;
  gap: 1%;
  margin: 0%;
  margin-top: 1%;

  align-items: center !important;
  justify-items: center !important;

  * {
    align-self: center !important;
    margin: 0%;

    @include media-breakpoint-down(sm) {
      margin-top: 1%;
    }
  }

  @include media-breakpoint-down(xs) {
    margin-top: 3%;

    flex-direction: column;

    h5 {
      margin-right: auto;
      margin-bottom: 1%;
    }

    .dropdown-publications-years {
      width: 85% !important;
    }
  }
}

.search-bar {
  width: 70%;
  min-width: 17em !important;

  @include media-breakpoint-down(xs) {
    width: 100%;
  }
}

#year_dropdown {
  min-width: min-content;
}

#type_dropdown {
  min-width: min-content !important;
}
</style>
